/* Imports */
import React from "react"
import { Font, Section } from "fajny-react"

import PageLayout from "../components/PageLayout"
import CodeContainer from "../components/CodeContainer"

import siteData from "../data/site-data"

const GettingStarted = () => {
    return (
        <PageLayout title="Getting started">
            <Font.H1>Getting started</Font.H1>

            <Font.H2>Install Fajny React in your project</Font.H2>

            <Section>
                <Section gap="small" as="div">
                    <Font.P>Open your app in a terminal, and run:</Font.P>

                    <CodeContainer language="shell">
                        {siteData.npmReact}
                    </CodeContainer>
                </Section>

                <Section gap="small" as="div">
                    <Font.P>
                        Now, open your <code>index.js</code> file, and import
                        the base CSS at the top of the page:
                    </Font.P>

                    <CodeContainer>{siteData.cssReact}</CodeContainer>
                </Section>
            </Section>

            <Font.P>
                For all components, we're using{" "}
                <a
                    href="https://styled-components.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    styled-components
                </a>
                .
            </Font.P>

            <Section>
                <Font.H3>Overrides</Font.H3>

                <Section gap="small" as="div">
                    <Font.P>
                        To override all variables, create a <code>.css</code>{" "}
                        file, and import it in your <code>index.js</code> file
                        after Fajny css file:
                    </Font.P>

                    <CodeContainer>
                        {`${siteData.cssReact}\nimport "./styles/name-of-file.css"`}
                    </CodeContainer>
                </Section>

                <Section gap="small" as="div">
                    <Font.P>
                        Then, in your new <code>css</code> file, create a{" "}
                        <code>:root</code> element and change the variables:
                    </Font.P>

                    <CodeContainer language="css">
                        {":root {\n    --color-primary-500: #445BE4;\n}"}
                    </CodeContainer>
                </Section>
            </Section>

            <Section gap="small">
                <Font.H2>JS Utils</Font.H2>

                <Font.P>
                    To ease the development process, we're using an{" "}
                    <a
                        href="https://www.npmjs.com/package/js-utils-julseb"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        npm package
                    </a>{" "}
                    for JS util functions:
                </Font.P>

                <CodeContainer language="shell">
                    {siteData.npmUtils}
                </CodeContainer>
            </Section>
        </PageLayout>
    )
}

export default GettingStarted
